module.exports = __webpack_public_path__ + "img/bg_main0603.a4fc8b34.png";